import styled from 'styled-components';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';

export const BodyWrapper = styled.div`
  padding: 24px 24px 12px 24px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const InnerWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
`;

export const FooterWrapper = styled.div`
  padding: 0;
`;

export const DeleteButton = styled(BaseButton)`
  min-width: 190px;

  &&& {
    background-color: var(--error-color);
    border-color: var(--error-color);
    color: var(--text-secondary-color);

    &:hover,
    &:focus {
      background-color: var(--error-color);
      border-color: var(--error-color);
      color: var(--text-secondary-color);
      opacity: 0.85;
    }
  }
`;
